module.exports = __webpack_public_path__ + "static/media/glass-3-x@3x.11fa0aef.png";